/* eslint-disable no-useless-concat */
import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { SecuredNavLink } from "../HOC/CustomComponents/Secured";
import { Typography, Paper, Toolbar, IconButton, Icon } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { gql, useQuery } from "@apollo/client";
import { KeyValuePair } from "../HOC/CustomComponents/KeyValuePair";
import { SAFE_ID } from "./Graphql";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import TreasurersTable from "./TreasurersTable";
import { Globals } from "../HOC/Classes/Globals";
import Grid from "@mui/material/Unstable_Grid2";

const PREFIX = 'SafeView';

const classes = {
  loading: `${PREFIX}-loading`,
  paper: `${PREFIX}-paper`,
  toolbar: `${PREFIX}-toolbar`,
  toolbarIcons: `${PREFIX}-toolbarIcons`,
  iconButton: `${PREFIX}-iconButton`,
  iconColor: `${PREFIX}-iconColor`,
  main: `${PREFIX}-main`,
  field: `${PREFIX}-field`,
  spanStyle: `${PREFIX}-spanStyle`
};

const StyledGrid = styled(Grid)((
  {
    theme
  }
) => ({
  [`& .${classes.loading}`]: {},

  [`& .${classes.paper}`]: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },

  [`& .${classes.toolbar}`]: {
    borderBottom: "1px #ccd1d6 solid",
    backgroundColor: "#f5f7f9",
    width: "100%",
  },

  [`& .${classes.toolbarIcons}`]: {
    flex: "1 1 100%",
    textAlign: "end",
  },

  [`& .${classes.iconButton}`]: {
    borderRadius: "0 4px 4px 0 ",
    boxShadow: "none",
    height: 45,
  },

  [`& .${classes.iconColor}`]: {
    color: theme.palette.success.main,
  },

  [`& .${classes.main}`]: {
    margin: 0,
    width: "100%",
  },

  [`& .${classes.field}`]: {
    width: 260,
    [theme.breakpoints.down("sm")]: {
      width: 170,
    },
  },

  [`& .${classes.spanStyle}`]: {
    display: "inline-block",
    // margin: "5px",
  }
}));

const SafeView = (props) => {

  const { t } = useTranslation();
  const safeId = props.match.params.id?.trim();
  const { loading, data } = useQuery(
    gql`
      ${SAFE_ID.query}
    `,
    {
      fetchPolicy: "network-only",
      variables: { id: parseInt(safeId) },
    }
  );
  const user = Globals.user;
  const branchId = data?.safe?.branch?.id;
  const canAccessBranch = branchId ? user.canAccessBranch(branchId) : true;

  const canEdit = user.hasPermission("cash.safe.update")
    ? canAccessBranch
    : false;
  const paymentTypes = data?.safe?.paymentTypes
    ?.map((i) => i.name)
    .toString()
    .replace(/,/g, " , ");
  return (
    <StyledGrid
      container
      justifyContent="center"
      className={classes.mainTracking}
      sx={{ margin: "0", width: "100%" }}
    >
      {loading ? (
        <FullScreenLoading minHeight="25%" />
      ) : (
        <>
          <Fragment>
            <Toolbar className={clsx(classes.toolbar)} variant="regular">
              <Grid
                container
                sx={{ flexWrap: "initial", flexGrow: 1 }}
                alignItems="center"
              >
                <Grid className={classes.field}>
                  <Typography variant="h6">{t(`safesDetails`)}</Typography>
                </Grid>
                <Grid className={classes.toolbarIcons}>
                  <SecuredNavLink
                    permission={canEdit}
                    to={{
                      pathname: `/admin/safes/${safeId}/edit`,
                    }}
                  >
                    <IconButton color={"primary"} size="large">
                      <Edit fontSize="inherit" />
                    </IconButton>
                  </SecuredNavLink>
                </Grid>
              </Grid>
            </Toolbar>
          </Fragment>

          <Grid
            container
            justifyContent="center"
            sx={{ width: "100%", p: 2, gap: 2 }}
          >
            <Paper container className={classes.paper} component={Grid}>
              <KeyValuePair title={t("code")} value={data?.safe?.code} />
              <KeyValuePair title={t("name")} value={data?.safe?.name} />
              <KeyValuePair
                title={t("active")}
                value={
                  data?.safe?.active ? (
                    <Icon className={classes.iconColor}>
                      check_circle_outline
                    </Icon>
                  ) : (
                    <Icon color="error">highlight_off</Icon>
                  )
                }
              />
              <KeyValuePair
                title={t("branch")}
                value={data?.safe?.branch?.name}
              />
              <KeyValuePair
                title={t("glAccount")}
                value={data?.safe?.glAccount?.name}
              />
              <KeyValuePair
                title={t("paymentTypes")}
                value={paymentTypes}
              />
            </Paper>
          </Grid>
        </>
      )}
      {data?.safe?.treasurers && (
        <TreasurersTable treasurers={data.safe?.treasurers} />
      )}
    </StyledGrid>
  );
};

export default SafeView;
